import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const YearsInfoContainer = styled(FlexContainer)<{
  $itemsLength: number;
  $isCompensation: boolean;
}>`
  border-radius: ${({ $itemsLength, theme: { sizing } }) =>
    $itemsLength === 1 ? sizing.fds_borderradius_M : sizing.fds_borderradius_L};
  padding: ${({ theme: { reference } }) => reference.dimension_08};
  background-color: ${({ $itemsLength, $isCompensation, theme: { system } }) =>
    $itemsLength === 1
      ? system.background.fds_sys_color_background_success_strong
      : $isCompensation
        ? system.background.fds_sys_color_background_cold
        : system.background.fds_sys_color_background_supersoft};
  width: ${({ $itemsLength }) => ($itemsLength === 1 ? '358px' : '100%')};
`;

export const PreviousYearsFeeContainer = styled(FlexContainer)`
  width: 358px;
  padding: ${({ theme: { reference } }) => `${reference.dimension_08} ${reference.dimension_16}`};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const YearsContainer = styled(FlexContainer)`
  max-width: 358px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;
export const YearsContent = styled(FlexContainer)`
  padding-left: ${({ theme: { reference } }) => reference.dimension_16};
  padding-right: ${({ theme: { reference } }) => reference.dimension_16};
`;

export const TotalRecoveredContainer = styled(FlexContainer)<{
  $isCompensationAndPay: boolean;
  $isZeroCompensation: boolean;
}>`
  background-color: ${({ $isCompensationAndPay, $isZeroCompensation, theme: { system } }) =>
    $isCompensationAndPay
      ? system.background.fds_sys_color_background_cold
      : $isZeroCompensation
        ? system.background.fds_sys_color_background_supersoft
        : system.background.fds_sys_color_background_success_strong};
  padding: ${({ theme: { reference } }) => reference.dimension_08};
  width: 358px;
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_M};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;
export const BannerContainer = styled(FlexContainer)`
  width: 358px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;
